import { Head } from "@inertiajs/react"
import { AdminShell } from "@/components/AdminShell"

type EntityStats = {
  total: number
  this_week: number
  this_month: number
  this_year: number
}

type Stats = {
  bands: EntityStats
  people: EntityStats
  recordings: EntityStats
  members: EntityStats
  venues: EntityStats
  gigs: EntityStats
  record_labels: EntityStats
  credits: EntityStats
  videos: EntityStats
  links: EntityStats
}

export default function AdminDashboard({ stats }: { stats: Stats }) {
  const rows: Array<{ label: string; key: keyof Stats; href: string }> = [
    { label: "Bands", key: "bands", href: "/bands" },
    { label: "People", key: "people", href: "/admin/people" },
    { label: "Recordings", key: "recordings", href: "/recordings" },
    { label: "Members", key: "members", href: "/admin/members" },
    { label: "Venues", key: "venues", href: "/admin/venues" },
    { label: "Gigs", key: "gigs", href: "/admin/gigs" },
    { label: "Record Labels", key: "record_labels", href: "/admin/record_labels" },
    { label: "Credits", key: "credits", href: "/credits/new" },
    { label: "Videos", key: "videos", href: "/videos/new" },
    { label: "Links", key: "links", href: "/links/new" },
  ]

  return (
    <>
      <Head title="Admin Dashboard">
        <meta name="description" content="Admin dashboard for the Australian Music Database." />
        <meta property="og:title" content="Admin Dashboard" />
        <meta property="og:description" content="Admin dashboard for the Australian Music Database." />
      </Head>
      <AdminShell>
        <div className="border-b border-hairline pb-6">
          <h1>Dashboard</h1>
          <p className="mt-1">Overview of database content.</p>
        </div>

        <div className="mt-6 overflow-hidden rounded-md border border-hairline bg-page">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-hairline bg-surface">
                <th className="px-4 py-2 text-left text-ink-muted font-medium">Entity</th>
                <th className="px-4 py-2 text-right text-ink-muted font-medium">Total</th>
                <th className="px-4 py-2 text-right text-ink-muted font-medium">This week</th>
                <th className="px-4 py-2 text-right text-ink-muted font-medium">This month</th>
                <th className="px-4 py-2 text-right text-ink-muted font-medium">This year</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-hairline">
              {rows.map(({ label, key, href }) => {
                const s = stats[key]
                return (
                  <tr key={key} className="hover:bg-surface">
                    <td className="px-4 py-2">
                      <a href={href} className="text-ink-display no-underline hover:underline">
                        {label}
                      </a>
                    </td>
                    <td className="px-4 py-2 text-right text-ink-body">{s.total}</td>
                    <td className="px-4 py-2 text-right text-ink-muted">{s.this_week}</td>
                    <td className="px-4 py-2 text-right text-ink-muted">{s.this_month}</td>
                    <td className="px-4 py-2 text-right text-ink-muted">{s.this_year}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </AdminShell>
    </>
  )
}
